import {CopilotAvatar} from '@github-ui/copilot-avatar'
import {GitHubAvatar} from '@github-ui/github-avatar'
import {hovercardAttributesForActor} from '@github-ui/hovercards'
import {Link} from '@primer/react'
import {clsx} from 'clsx'

import assigneeStyles from './Assignee.module.css'
import styles from './Assignees.module.css'

type Props = {
  login: string
  avatarUrl: string
  isCopilot: boolean
  className?: string
  /**
   * Href getter for the assignee link
   * @param name - name of the assignee
   * @returns URL to the assignee
   */
  getAssigneeHref: (assignee: string) => string
}

export function Assignee({login, avatarUrl, isCopilot, getAssigneeHref, className}: Props) {
  const displayName = isCopilot ? 'Copilot' : login
  const hovercardAttributes = hovercardAttributesForActor(login, {isCopilot})

  return (
    <Link
      aria-label={`${displayName} is assigned`}
      href={getAssigneeHref(isCopilot ? '@copilot' : login)}
      {...hovercardAttributes}
      className={clsx(className, 'pc-AvatarItem', styles.assigneeIconLink)}
    >
      {isCopilot ? (
        <CopilotAvatar key={login} size={'small'} />
      ) : (
        <GitHubAvatar key={login} alt={displayName} src={avatarUrl} className={assigneeStyles.AssigneeAvatar} />
      )}
    </Link>
  )
}

try{ Assignee.displayName ||= 'Assignee' } catch {}